var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "6.472%",
    x2: "93.528%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5141E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DE39FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "6.472%",
    x2: "93.528%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5141E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DE39FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "139.8%",
    height: "139.8%",
    x: "-19.9%",
    y: "-19.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0452633304 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 44,
    cy: 44,
    r: 44
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4F1181",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M25.204 47.807l.413-1.236h2.646l.412 1.236h2.264l-2.996-7.615h-2.01L23 47.807h2.204zm2.558-2.878h-1.644l.818-2.36.826 2.36zM34.818 48c1.989 0 3.513-1.36 3.797-3.362H36.51c-.209.847-.86 1.397-1.688 1.397-1.057 0-1.833-.854-1.833-2.029 0-1.179.776-2.046 1.833-2.046.785 0 1.43.507 1.687 1.288h2.083C38.29 41.318 36.775 40 34.818 40c-2.272 0-3.969 1.716-3.969 4.006 0 2.278 1.697 3.994 3.97 3.994zm8.293 0c1.988 0 3.512-1.36 3.796-3.362h-2.103c-.21.847-.86 1.397-1.689 1.397-1.057 0-1.832-.854-1.832-2.029 0-1.179.775-2.046 1.832-2.046.786 0 1.43.507 1.687 1.288h2.084C46.582 41.318 45.067 40 43.11 40c-2.272 0-3.97 1.716-3.97 4.006 0 2.278 1.698 3.994 3.97 3.994zm8.434 0c2.393 0 4.1-1.666 4.1-4s-1.707-4-4.1-4c-2.4 0-4.112 1.673-4.112 4s1.712 4 4.112 4zm0-1.952c-1.136 0-1.971-.862-1.971-2.048 0-1.185.835-2.048 1.97-2.048 1.137 0 1.96.856 1.96 2.048 0 1.192-.823 2.048-1.96 2.048zM59.807 48c1.903 0 3.259-1.265 3.259-3.138v-4.67h-2.102v4.63c0 .745-.47 1.226-1.157 1.226s-1.157-.481-1.157-1.226v-4.63h-2.102v4.67c0 1.873 1.356 3.138 3.259 3.138zm6.551-.193v-4.132l2.966 4.132h1.7v-7.615h-1.992v3.996l-2.867-3.996h-1.8v7.615h1.993zm9.614 0v-5.726H78v-1.889h-6.121v1.89h2.028v5.725h2.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M7.421 7.953L3.71 0 0 7.953z",
    transform: "translate(10 40)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M10.913 7.953L7.202 0l-3.71 7.953z",
    transform: "translate(10 40)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.903d6cd02abadf4b4d6025e127c92838.svg";
export { ForwardRef as ReactComponent };